import { useLocation } from 'react-router-dom';
import { ApiExplorerPage } from '@backstage/plugin-api-docs';

/**
 * Remounts the API explorer when the history entry changes so filters
 * rehydrate from the URL after browser Back/Forward.
 */
export const ApiExplorerPageWithUrlSync = () => {
  const location = useLocation();
  return <ApiExplorerPage key={`${location.key}:${location.search}`} />;
};
